import React from "react";
import { motion } from "framer-motion";
interface PageTransitionProps {
  children: React.ReactNode;
}
const PageTransition = ({
  children
}: PageTransitionProps) => {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -10
  }} transition={{
    duration: 0.3
  }} className="w-full px-[10px]">
      {children}
    </motion.div>;
};
export default PageTransition;